export default function Footer() {
    return (
      <footer className="fixed bottom-0 right-0 left-0 footer footer-center h-16 bg-black text-white z-50">
          <div className="container mx-auto flex items-center justify-center h-full">
          <p>
            Copyright © {new Date().getFullYear()} - All rights reserved by HRIS Central Retail Corporation Public Co.,Ltd.
          </p>
          </div>
      </footer>
    );
  }
  